import { mapGetters } from 'vuex';
import contentHeader from '@/components/generics/content-header/content-header.vue';
import loaderMixin from '@/mixins/loader';
import notificationsList from '@/components/notifications-list/notifications-list.vue';
import unreadNotificationMixin from '@/mixins/unreadNotification';
import seoMetaMixin from '@/mixins/seoMeta';

export default {
  mixins: [
    loaderMixin,
    unreadNotificationMixin,
    seoMetaMixin,
  ],
  components: {
    contentHeader,
    notificationsList,
  },
  metaInfo() {
    return this.buildSeoMeta({
      title: 'Notifications',
    });
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop', 'isLayoutMobile']),
  },
  beforeDestroy() {
    this.clearAllNotifications();
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/dashboard/page-dashboard-sushi/pages/sushi-notifications/sushi-notifications.js